import { graphql } from "gql";

const HAPPYCO_USERS_QUERY = graphql(`
  query HappycoUsers {
    happycoUsers {
      ...HappycoUser
    }
  }
`);

export default HAPPYCO_USERS_QUERY;
